export var TextFieldTheme;
(function (TextFieldTheme) {
    TextFieldTheme["Line"] = "line";
    TextFieldTheme["Box"] = "box";
})(TextFieldTheme || (TextFieldTheme = {}));
export var TextFieldLabelStyle;
(function (TextFieldLabelStyle) {
    TextFieldLabelStyle["Regular"] = "regular";
    TextFieldLabelStyle["Floating"] = "floating";
})(TextFieldLabelStyle || (TextFieldLabelStyle = {}));
//# sourceMappingURL=types.js.map